import { useDispatch } from "react-redux";

import { BullseyePointerRegularV6 } from "@shared/v2/Icomoon";

import ActivityContainer from "./ActivityContainer";
import { activityCommonDefaultProps, activityCommonPropTypes, STYLES } from "../common";
import Header from "./Header";
import CategoryContainer from "./CategoryContainer";
import DataField from "./DataField";
import ActivityBtns from "./shared/ActivityBtns";
import { setCallParams } from "../../../../reducers/dialerReducer/dialerReducer";

const EngagedWithAdActivity = ({ activity, onReadChange }) => {
  const dispatch = useDispatch();

  return (
    <ActivityContainer activity={activity} onReadChange={onReadChange}>
      <Header
        category={
          <CategoryContainer
            containerClassName="tw-bg-[#FAE6F0] tw-text-[#A31D61]"
            Icon={BullseyePointerRegularV6}
          >
            Engaged With Digital Ad
          </CategoryContainer>
        }
        personName={`${activity.data?.subjectFirstName} ${activity.data?.subjectLastName}`}
        time={activity.createdAt}
        onReadChange={onReadChange}
        loading={activity.loading}
        read={activity.read}
      />
      <div className={`${STYLES.contentContainer} tw-text-14d`}>
        {activity.data.digitalAdTitle && <DataField label="Ad" data={activity.data.digitalAdTitle} />}
        {activity.data.subjectEmail && <DataField label="Email" data={activity.data.subjectEmail} />}
        {activity.data.subjectPhoneNumber && (
          <DataField label="Phone" data={activity.data.subjectPhoneNumber} />
        )}
        {activity.data.source && <DataField label="Source" data={activity.data.source} />}
      </div>
      <ActivityBtns
        callHandlr={() => {
          if (activity.data?.personUuid) {
            dispatch(
              setCallParams({
                leadUuids: [activity.data?.personUuid],
                callSource: "Engaged With Ad Activity",
              }),
            );
          }
        }}
        containerClassName="!tw-mt-8px"
      />
    </ActivityContainer>
  );
};

export default EngagedWithAdActivity;

EngagedWithAdActivity.propTypes = {
  ...activityCommonPropTypes,
};

EngagedWithAdActivity.defaultProps = {
  ...activityCommonDefaultProps,
};
